import script from "./ESportsLiveFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./ESportsLiveFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./ESportsLiveFixtureBook.vue?vue&type=style&index=0&id=26fbb409&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26fbb409"]])

export default __exports__